import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { getUsersSelector, getUsersStatsSelector } from '../users.reducer';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'cc-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  public user;
  public id;
  public state;
  public userStats;
  public userList;

  constructor(private store: Store<IState>, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.parent.paramMap.subscribe((params: ParamMap) => {
      this.state = params.get('state');
      this.getUsersBasedOnParams();
    });

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id');
      this.getUsersBasedOnParams();
    });
  }

  getUsersBasedOnParams() {
    this.store.select(getUsersSelector).subscribe(userList => {
      this.userList = userList;
      this.user = userList.find(
        user =>
          Number(this.id) !== 0 || this.state === 'all'
            ? user.username === this.id || user.uniqueId === parseInt(this.id, 10)
            : user.state.toLowerCase() === this.state
      );
    });
    this.store.select(getUsersStatsSelector).subscribe(userStats => (this.userStats = userStats));
  }
}
